import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

interface Props {
  height?: number;
  href?: string | null;
  isCollapsed?: boolean;
}

export const Logo: FC<Props> = ({ height = 20, href = '/', isCollapsed }) => {
  const logo = useMemo(
    () => (
      <Box
        component="img"
        src={isCollapsed ? '/images/AI.png' : '/images/FullglassAI.png'}
        alt="Fullglass AI logo"
        height={height}
        sx={{ maxWidth: '100%', objectFit: 'contain' }}
      />
    ),
    [height, isCollapsed]
  );

  return href ? (
    <Link to={href} style={{ display: 'flex' }}>
      {logo}
    </Link>
  ) : (
    logo
  );
};
